export default "__VITE_ASSET__5ab7ccdb__"